(() => {
  const SELECTOR = '[data-cart-expected-delivery]';
  const TZ = 'Europe/Sofia';
  const CUT_OFF_HOUR = 12;

  const pad2 = (n) => String(n).padStart(2, '0');
  const fmtDM = (d) => `${pad2(d.getDate())}.${pad2(d.getMonth() + 1)}`;

  function nowInTZ(tz) {
    try {
      return new Date(new Date().toLocaleString('en-US', { timeZone: tz }));
    } catch (e) {
      return new Date();
    }
  }

  function orthodoxEasterSunday(y) {
    const a = y % 4, b = y % 7, c = y % 19;
    const d = (19 * c + 15) % 30;
    const e = (2 * a + 4 * b - d + 34) % 7;
    const m = Math.floor((d + e + 114) / 31);
    const day = ((d + e + 114) % 31) + 1;
    const dt = new Date(y, m - 1, day);
    dt.setDate(dt.getDate() + 13);
    return dt;
  }

  function sameDay(a, b) {
    return a.getFullYear() === b.getFullYear()
      && a.getMonth() === b.getMonth()
      && a.getDate() === b.getDate();
  }

  function isWeekend(d) { return d.getDay() === 0 || d.getDay() === 6; }

  function bgHolidays(y) {
    const fixed = [
      new Date(y, 0, 1), new Date(y, 2, 3),
      new Date(y, 4, 1), new Date(y, 4, 6), new Date(y, 4, 24),
      new Date(y, 8, 6), new Date(y, 8, 22),
      new Date(y, 11, 24), new Date(y, 11, 25), new Date(y, 11, 26)
    ];

    // one-off non-working days (BG)
    if (y === 2025) fixed.push(new Date(2025, 11, 31)); // 31.12.2025
    if (y === 2026) fixed.push(new Date(2026, 0, 2));   // 02.01.2026

    const easter = orthodoxEasterSunday(y);
    const gf = new Date(easter); gf.setDate(gf.getDate() - 2);
    const gs = new Date(easter); gs.setDate(gs.getDate() - 1);
    const em = new Date(easter); em.setDate(em.getDate() + 1);

    const base = fixed.concat([gf, gs, easter, em]);

    const all = base.slice();
    base.forEach((h) => {
      if (isWeekend(h)) {
        const obs = new Date(h);
        do { obs.setDate(obs.getDate() + 1); }
        while (isWeekend(obs) || base.some((x) => x.getTime() === obs.getTime()));
        if (!all.some((x) => x.getTime() === obs.getTime())) all.push(obs);
      }
    });

    return all;
  }

  function makeCalendar(now) {
    const y = now.getFullYear();
    const hol = bgHolidays(y).concat(bgHolidays(y + 1));

    function isHoliday(d) {
      for (let i = 0; i < hol.length; i++) {
        if (sameDay(hol[i], d)) return true;
      }
      return false;
    }

    function isBusiness(d) { return !isWeekend(d) && !isHoliday(d); }

    function nextBusinessDay(d) {
      const x = new Date(d);
      while (!isBusiness(x)) x.setDate(x.getDate() + 1);
      return x;
    }

    function addBusinessDaysFrom(base, days) {
      let d = new Date(base);
      d.setDate(d.getDate() + 1);
      let added = 0;

      while (added < days) {
        if (isBusiness(d)) added++;
        if (added < days) d.setDate(d.getDate() + 1);
      }

      while (!isBusiness(d)) d.setDate(d.getDate() + 1);
      return d;
    }

    return { isBusiness, nextBusinessDay, addBusinessDaysFrom };
  }

  function computeAndFill(container) {
    if (!container) return;

    const betweenEl = container.querySelector('[data-role="between"]');
    const tlWrap = container.querySelector('[data-role="timeline"]');
    const leftEl = container.querySelector('[data-role="leftDate"]');
    const rightEl = container.querySelector('[data-role="rightDate"]');
    if (!betweenEl) return;

    const lang = (container.getAttribute('data-lang') || 'bg').toLowerCase();
    const isEN = lang.includes('en');

    const isBTS = (container.getAttribute('data-bts') === 'true');
    let minDays = parseInt(container.getAttribute('data-agg-min') || '2', 10);
    let maxDays = parseInt(container.getAttribute('data-agg-max') || '4', 10);
    if (isBTS) { minDays = 12; maxDays = 12; }

    const now = nowInTZ(TZ);
    const cal = makeCalendar(now);

    let base = new Date(now);
    if (now.getHours() >= CUT_OFF_HOUR) base.setDate(base.getDate() + 1);
    base = cal.isBusiness(base) ? base : cal.nextBusinessDay(base);

    const minDate = cal.addBusinessDaysFrom(base, minDays);
    const maxDate = cal.addBusinessDaysFrom(base, maxDays);

    const baseTxt = fmtDM(base);
    const startTxt = fmtDM(minDate);
    const endTxt = fmtDM(maxDate);

    betweenEl.textContent =
      (minDays === maxDays)
        ? (isEN ? `Delivery on ${startTxt}` : `Доставка на ${startTxt}`)
        : (isEN ? `Delivery between ${startTxt}–${endTxt}` : `Доставка между ${startTxt}–${endTxt}`);

    betweenEl.classList.remove('is-loading');

    if (tlWrap && leftEl && rightEl) {
      tlWrap.style.display = '';
      leftEl.textContent = baseTxt;
      rightEl.textContent = (minDays === maxDays) ? startTxt : `${startTxt}–${endTxt}`;
    }
  }

  let rafId = null;

  function initOnce() {
    const nodes = document.querySelectorAll(SELECTOR);
    if (!nodes || nodes.length === 0) return false;
    nodes.forEach(computeAndFill);
    return true;
  }

  function initAll(retryFrames = 10) {
    if (rafId) cancelAnimationFrame(rafId);
    rafId = requestAnimationFrame(() => {
      rafId = null;
      const ok = initOnce();
      if (!ok && retryFrames > 0) initAll(retryFrames - 1);
    });
  }

  window.NBExpectedDeliveryInit = initAll;

  initAll(10);
  document.addEventListener('DOMContentLoaded', () => initAll(10));
  document.addEventListener('dispatch:cart-expected-delivery:init', () => initAll(10));
})();
